enum StatusDivergenciaEnum {
  NOVO = 'NOVO',
  EM_ANDAMENTO = 'EM_ANDAMENTO',
  AGUARDANDO_FINALIZACAO = 'AGUARDANDO_FINALIZACAO',
  FINALIZADO = 'FINALIZADO',
}

export default StatusDivergenciaEnum;
